var $110bdd83348ecbc0$exports = {};
$110bdd83348ecbc0$exports = {
  "dragDescriptionKeyboard": "Lohistamise alustamiseks vajutage klahvi Enter.",
  "dragDescriptionKeyboardAlt": "Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.",
  "dragDescriptionLongPress": "Vajutage pikalt lohistamise alustamiseks.",
  "dragDescriptionTouch": "Topeltpuudutage lohistamise alustamiseks.",
  "dragDescriptionVirtual": "Kl\xF5psake lohistamise alustamiseks.",
  "dragItem": function dragItem(args) {
    return "Lohista ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Lohista ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valitud \xFCksust");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valitud \xFCksust");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      }
    }), " lohistamiseks vajutage sisestusklahvi Enter.");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      }
    }), " jaoks.");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Pikk vajutus ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valitud \xFCksuse");
      }
    }), " lohistamiseks.");
  },
  "dragStartedKeyboard": "Alustati lohistamist. Kukutamise sihtm\xE4rgi juurde navigeerimiseks vajutage klahvi Tab, seej\xE4rel vajutage kukutamiseks klahvi Enter v\xF5i loobumiseks klahvi Escape.",
  "dragStartedTouch": "Alustati lohistamist. Navigeerige kukutamise sihtm\xE4rgi juurde ja topeltpuudutage kukutamiseks.",
  "dragStartedVirtual": "Alustati lohistamist. Navigeerige kukutamise sihtm\xE4rgi juurde ja kukutamiseks kl\xF5psake v\xF5i vajutage klahvi Enter.",
  "dropCanceled": "Lohistamisest loobuti.",
  "dropComplete": "Lohistamine on tehtud.",
  "dropDescriptionKeyboard": "Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.",
  "dropDescriptionTouch": "Kukutamiseks topeltpuudutage.",
  "dropDescriptionVirtual": "Kukutamiseks kl\xF5psake.",
  "dropIndicator": "lohistamise indikaator",
  "dropOnItem": function dropOnItem(args) {
    return "Kukuta asukohta ".concat(args.itemText);
  },
  "dropOnRoot": "Kukuta asukohta",
  "endDragKeyboard": "Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.",
  "endDragTouch": "Lohistamine. Lohistamisest loobumiseks topeltpuudutage.",
  "endDragVirtual": "Lohistamine. Lohistamisest loobumiseks kl\xF5psake.",
  "insertAfter": function insertAfter(args) {
    return "Sisesta ".concat(args.itemText, " j\xE4rele");
  },
  "insertBefore": function insertBefore(args) {
    return "Sisesta ".concat(args.itemText, " ette");
  },
  "insertBetween": function insertBetween(args) {
    return "Sisesta ".concat(args.beforeItemText, " ja ").concat(args.afterItemText, " vahele");
  }
};
export { $110bdd83348ecbc0$exports as default };